<template>
  <div class="h-screen pt-6 flex flex-col bg-white">
    <Container class="w-full">
      <PageHeading :title="this.$t('pages.admin.firmware.firmware_admin_layout.admin_firmware')"/>
    </Container>

    <TabLayout :tabs="tabs"/>

    <div class="flex-1 flex flex-col overflow-hidden">
      <router-view class="flex-1"></router-view>
    </div>

  </div>
</template>

<script>
import TabLayout from "@/Layouts/TabLayout.vue";
import PageHeading from "@/Components/PageHeading.vue";
import Container from "@/Components/Container.vue";

export default {
  name: "FirmwaresAdminLayout",
  components: {Container, PageHeading, TabLayout},
  data() {
    return {}
  },
  computed: {
    isProduction() {
      return import.meta.env.VITE_APP_ENV === 'production';
    },
    tabs() {
      return [
        {
          label: this.$t('pages.admin.firmware.firmware_admin_layout.firmware'),
          current: this.$route.name === 'admin.firmware' || this.$route.name.startsWith('admin.firmware.firmware'),
          to: {name: 'admin.firmware'},
          permission: 'create:firmwares|update:firmwares',
        },
        {
          label: this.$t('pages.admin.firmware.firmware_admin_layout.types'),
          current: this.$route.name === 'admin.firmware.types' || this.$route.name.startsWith('admin.firmware.types.type'),
          to: {name: 'admin.firmware.types'},
          permission: 'create:firmware-types|update:firmware-types',
        },
        {
          label: this.$t('pages.admin.firmware.firmware_admin_layout.bulk_generate'),
          current: this.$route.name === 'admin.firmware.bulk',
          to: {name: 'admin.firmware.bulk'},
          permission: 'create:firmwares',
          hidden: this.isProduction,
        },
      ].filter(t => (t.permission === undefined || this.$auth.hasPermission(t.permission)) && !t.hidden)
    }
  },
}
</script>

<style scoped>

</style>